





import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { VueTelInput, VueTelInputResponse, VueTelInputComputed } from 'vue-tel-input';

@Component({
  name: 'InputPhone',
  components: {
    VueTelInput,
  },
})
export default class InputPhone extends Vue {
  @Prop({default: '', type: String}) private value!: string;

  @Prop({default: false, type: Boolean}) private required!: boolean;

  private mounted() {
    this.checkInitialValue();
  }

  private checkInitialValue(){
    // @ts-ignore
    const phoneObject = (this.$refs['tel-input'].phoneObject.isValid)
    if (!this.required && !this.value) {
      // @ts-ignore
      this.$refs['tel-input'].$refs.input.setCustomValidity('');
    }

    if (!!this.value) {
      // @ts-ignore
      this.$refs['tel-input'].$refs.input.setCustomValidity(this.$attrs.invalidMsg || '');
    }
  }

  private handleInput(newValue: string, response: VueTelInputResponse) {
    if (!this.required && !newValue) {
      // @ts-ignore
      this.$refs['tel-input'].$refs.input.setCustomValidity('');
    }
    this.$emit('input', newValue, response);
  }

};
